<template>
  <div class="home">
    <!-- <div class="home-banner" ref="pronbit" id="banner">
      <div class="banner" :class="{ 'banner-fixed': show }">
        <div class="banner-logo">
          <img :src="logo" />
        </div>
        <div class="banner-menu" :class="{ 'menu-fixed': show }">
          <div class="nav-line">
            <div class="nav-line-box">
              <div
                class="nav-line-div"
                :style="{
                  transform: 'translateX(' + translateX + 'px)',
                  width: lineWidth,
                }"
              ></div>
            </div>
          </div>
          <div class="nav-list">
            <div class="nav-list-box">
              <div
                class="nav-list-div"
                v-for="(item, index) in menuList"
                :key="index"
                @click="changeTitle(index)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutUS">
      <div class="aboutUS-left">
        <div class="aboutUS-left-title">关于普康</div>
        <div class="aboutUS-left-titleEn">About us</div>
        <div class="aboutUS-left-content1">
          普康软件是医疗行业领先的病案生命周期全流程管理解决方案公司，是医疗行业信息技术创新变革的推动者和病案智能化管理转型的新一代引领者。普康成立于2018年，以“信息技术赋能业务，提升医疗管理水平”为使命，始终洞察医疗行业发展趋势，探索信息技术的创新与应用，赋能全国数万家大中型医疗服务机构实现病案智能化管理，全面提升病案管理的效率和质量。
        </div>
        <div class="aboutUS-left-content2">
          普康，以医疗服务机构全面提升医疗服务质量为目标，通过AI人工智能与医疗服务大数据研究方法，深入挖掘探索医疗大数据在医疗质量安全水平管理的更广泛应用，目前，普康已拥有自主研发的病案首页质控、病历质控、医保结算清单质控、公立绩效考核管理、DIP运营监管等主要明星产品。
        </div>
        <div class="aboutUS-left-content3">
          面向未来，普康将持续秉持专业精神，紧跟国家医疗政策的发展，以更创新、更具价值的信息技术，优化和完善产品方案，赋能我们的客户。
        </div>
        <div
          class="aboutUS-left-btn"
          @mouseover="changeHover(true)"
          @mouseleave="changeHover(false)"
          @click="tarAbout"
        >
          了解更多
          <img :src="arrowRight1" v-if="!hover" />
          <img :src="arrowRight2" v-if="hover" />
        </div>
      </div>
      <div class="aboutUS-right">
        <img :src="logo3" />
      </div>
    </div> -->
    <pageHeader
      :actNum="0"
      :bannerImg="bannerImg"
      bannerText="- Innovation"
      bannerText2="Smart healthcare"
    />
    <homeBusiness />
    <homeSolution />
    <homeNews />
    <footPage />
  </div>
</template>

<script>
import logo from "@/assets/img/logo.png";
import logo3 from "@/assets/img/logo3.png";
import bannerImg from "@/assets/img/banner_index.png";
import arrowRight1 from "@/assets/img/arrow-right1.png";
import arrowRight2 from "@/assets/img/arrow-right2.png";
import iconLeft from "@/assets/img/icon_left.png";
import iconRight from "@/assets/img/icon_right.png";
import homeBusiness from "@/components/homeBusiness/index.vue";
import homeSolution from "@/components/homeSolution/index.vue";
import homeNews from "@/components/homeNews/index.vue";
import footPage from "@/components/foot/index.vue";
import pageHeader from "@/components/pageHeader/index.vue";
export default {
  name: "HomeView",
  components: {
    homeBusiness,
    homeSolution,
    homeNews,
    footPage,
    pageHeader
  },
  data() {
    return {
      logo,
      // banner,
      bannerImg,
      logo3,
      arrowRight1,
      arrowRight2,
      iconLeft,
      iconRight,
      show: false,
      menuList: [
        { label: "首页" },
        { label: "产品中心" },
        { label: "解决方案" },
        { label: "服务支持" },
        { label: "关于我们" },
        // { label: "联系我们" },
      ],
      translateX: null,
      lineWidth: null,
      hover: false,
      actNum: null,
      // businessLineWidth: null
    };
  },
  methods: {
    changeTitle(i) {
      this.setUnderLine(i);
      if (i == 1) {
        this.$router.push("/productCenter");
      } else if (i == 2) {
        this.$router.push("/solution");
      } else if (i == 3) {
        this.$router.push("/serviceSupport");
      } else if (i == 4) {
        this.$router.push("/aboutUs");
      } else if (i == 5) {
        this.$router.push("/contactUs");
      }
    },
    setUnderLine(index) {
      const navList = document.querySelector(".nav-list-box").offsetWidth;
      document.querySelector(".nav-line-box").style.width = navList + "px";
      const elements = document.querySelectorAll(".nav-list-div");
      // 获取边距
      const computedStyle = window.getComputedStyle(elements[0]);
      const marginDiv = computedStyle.marginRight.replace("px", "");
      // 修改下划线宽度
      document.querySelector(".nav-line-div").style.width =
        elements[index].offsetWidth + "px";
      // console.log(document.querySelector(".nav-line-div").style.width);
      this.lineWidth = elements[index].offsetWidth + "px";
      let numX = 0;
      elements.forEach((item, i) => {
        if (index > i) {
          numX = numX + item.offsetWidth;
        }
      });
      this.translateX = numX + marginDiv * (index * 2 + 1);
      this.actNum = index;
    },
    changeHover(val) {
      this.hover = val;
    },
    // 滚动距离
    handleScrollx() {
      // console.log(this.$refs.pronbit.getBoundingClientRect().top);
      if (this.$refs.pronbit.getBoundingClientRect().top == 0) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    tarAbout() {
      this.$router.push("/aboutUs");
    },
    handleResize() {
      // console.log(this.actNum);
      if (document.documentElement.clientWidth < 1280) {
        return;
      } else {
        this.setUnderLine(this.actNum);
      }
    },
  },
  mounted() {
    this.setUnderLine(0);
    // 监听滚动
    window.addEventListener("scroll", this.handleScrollx, true);
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("DOMContentLoaded", function () {
      var div = document.getElementById("banner");
      var height = window.innerHeight; // 获取当前窗口的高度
      console.log(height);
      div.style.height = height + "px"; // 设置 div 的高度为窗口高度
    });
  },
  beforeDestroy() {
    // 清除监听滚动
    window.removeEventListener("scroll", this.handleScrollx, true);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  color: #333;
  position: relative;
  &-banner {
    width: 100%;
    // height: 100vh;
    // height: 1080px;
    // padding: 34px 60px;
    box-sizing: border-box;
    background-image: url("../assets/img/banner.jpg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: top center;
    // background-size: cover;
    .banner {
      position: fixed;
      width: 100%;
      transition: transform 0.36s ease; /* 添加过渡效果 */
      transform: translateY(0); /* 初始位置 */
      z-index: 999;
      &-logo {
        padding-top: 34px;
        display: flex;
        justify-content: center;
        img {
          width: 275px;
          height: 60px;
        }
      }
      &-menu {
        margin-top: 35px;
        // margin: 0 auto;
        padding: 0 60px;
        .nav-line {
          margin: 0 auto;
          height: 1px;
          // background: transparent;
          background: rgba($color: #fff, $alpha: 0.3);
          display: flex;
          justify-content: center;
          &-div {
            width: 1px;
            height: 2px;
            transition-duration: 0.3s;
            background: #fff;
          }
        }
        .nav-list {
          display: flex;
          justify-content: center;
          // border-top: 1px solid rgba($color: #fff, $alpha: 0.3);
          &-box {
            display: flex;
          }
          &-div {
            margin: 30px 60px;
            // line-height: 32px;
            cursor: pointer;
            font-size: 16px;
            // font-weight: bold;
            color: #fff;
            position: relative;
          }
          &-div:before {
            content: "";
            position: absolute;
            left: 50%;
            // bottom: -2px;
            top: -31px;
            width: 0;
            height: 2px;
            background: #fff;
            transition: all 0.3s;
          }
          &-div:hover:before {
            width: 100%;
            left: 0;
            right: 0;
          }
        }
      }
    }
    .banner-fixed {
      background-color: #fff;
      transition: transform 0.36s ease; /* 添加过渡效果 */
      transform: translateY(-130px); /* 初始位置 */
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

      .nav-list-div {
        color: #333;
      }
      .nav-list-div:hover {
        color: #004f6a;
      }
    }
  }
}
</style>
